<template>
  <div class="z-10 flex-shrink-0 w-64 bg-cyan-700">
    <div class="flex items-center h-16 px-2 space-x-2 shadow-sm">
      <router-link
        to="/"
        class="
          flex
          items-center
          justify-center
          text-2xl
          font-semibold
          text-white
          rounded-lg
          w-9
          h-9
          bg-cyan-600
          focus:outline-none
        "
      >
        T
      </router-link>
      <div>
        <h1 class="text-xl font-semibold leading-4 tracking-wider text-white">
          masterTime
        </h1>
        <h3
          class="text-base font-semibold leading-5 tracking-wider text-cyan-100"
        >
          service
        </h3>
      </div>
    </div>

    <!-- customer menus -->
    <nav v-if="menusCustomerActive" class="px-2 py-4">
      <ul class="space-y-2">
        <li v-for="menu in menusCustomer" :key="menu.text">
          <router-link
            :to="menu.to"
            class="flex items-center px-2 py-2 space-x-4 rounded-md group"
          >
            <AppIcon
              className="h-5 w-5 text-cyan-100 group-hover:text-white transition duration-150"
            >
              <component :is="menu.icon" />
            </AppIcon>
            <span
              class="
                text-base
                font-medium
                transition
                duration-150
                text-cyan-100
                group-hover:text-white
              "
              >{{ menu.text }}</span
            >
          </router-link>
        </li>
      </ul>
    </nav>
    <!-- end customer menus -->

    <nav v-else class="px-2 py-4">
      <ul class="space-y-2">
        <li v-for="menu in menus" :key="menu.text">
          <router-link
            :to="menu.to"
            class="flex items-center px-2 py-2 space-x-4 rounded-md group"
          >
            <AppIcon
              className="h-5 w-5 text-cyan-100 group-hover:text-white transition duration-150"
            >
              <component :is="menu.icon" />
            </AppIcon>
            <span
              class="
                text-base
                font-medium
                transition
                duration-150
                text-cyan-100
                group-hover:text-white
              "
              >{{ menu.text }}</span
            >
          </router-link>
        </li>
      </ul>
      <div v-if="appVersion" class="absolute bottom-0 left-0">
        <p class="text-white font-medium px-4 py-2">{{ appVersion }}</p>
      </div>
    </nav>
  </div>
</template>

<script>
import AppIcon from '@/components/AppIcon'
import DashboardIcon from '@/components/icons/DashboardIcon'
import CustomerIcon from '@/components/icons/CustomerIcon'
import CustomerDetailsIcon from '@/components/icons/CustomerDetailsIcon'
import CustomerFeatureIcon from '@/components/icons/CustomerFeatureIcon'
import CustomerUseIcon from '@/components/icons/CustomerUseIcon'
import ChartPieIcon from '@/components/icons/ChartPieIcon'
import HardwareIcon from '@/components/icons/HardwareIcon'
import AdminIcon from '@/components/icons/AdminIcon'
import FirmwareIcon from '@/components/icons/FirmwareIcon'
import AnnouncementIcon from '@/components/icons/AnnouncementIcon.vue'
import WebhookIcon from '@/components/icons/WebhookIcon.vue'

export default {
  components: {
    AppIcon,
    DashboardIcon,
    CustomerIcon,
    CustomerDetailsIcon,
    CustomerFeatureIcon,
    CustomerUseIcon,
    ChartPieIcon,
    HardwareIcon,
    AdminIcon,
    AnnouncementIcon,
    FirmwareIcon,
    WebhookIcon,
  },

  data() {
    return {
      appVersion: process.env.VUE_APP_VERSION,
      menus: [
        { text: 'แดชบอร์ด', to: '/', icon: 'DashboardIcon' },
        { text: 'รายชื่อลูกค้า', to: '/customer', icon: 'CustomerIcon' },
        { text: 'ส่งประกาศ', to: '/announcement', icon: 'AnnouncementIcon' },
        { text: 'ผู้ดูแลระบบ', to: '/admin', icon: 'AdminIcon' },
        { text: 'ตั้งค่า Device', to: '/hardware', icon: 'HardwareIcon' },
        { text: 'เฟิร์มแวร์', to: '/firmware', icon: 'FirmwareIcon' },
      ],
    }
  },

  computed: {
    menusCustomerActive() {
      return this.$store.state.menusCustomerActive
    },

    menusCustomer() {
      return [
        {
          text: 'ข้อมูลลูกค้า (บริษัท)',
          to: `/customer/${this.$route.params.uuid}/details`,
          icon: 'CustomerDetailsIcon',
        },
        {
          text: 'ผู้ดูแลระบบลูกค้า',
          to: `/customer/${this.$route.params.uuid}/admin`,
          icon: 'AdminIcon',
        },
        {
          text: 'ตั้งค่าการใช้งานลูกค้า',
          to: `/customer/${this.$route.params.uuid}/use`,
          icon: 'CustomerUseIcon',
        },
        // {
        //   text: 'จัดการฟีเจอร์ลูกค้า',
        //   to: `/customer/${this.$route.params.uuid}/feature`,
        //   icon: 'CustomerFeatureIcon',
        // },
        {
          text: 'สรุปปริมาณการใช้งาน',
          to: `/customer/${this.$route.params.uuid}/usage-summary`,
          icon: 'ChartPieIcon',
        },
        {
          text: 'Webhook',
          to: `/customer/${this.$route.params.uuid}/webhook`,
          icon: 'WebhookIcon',
        },
      ]
    },
  },
}
</script>
